import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import ManagerWorkplaceCreateOptionsList from './ManagerWorkplaceCreateOptionsList';

interface Props extends BaseModalProps {
	onSuccess: () => void;
}

const ManagerWorkplaceCreateOptionsListModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.managerWorkplaceCreateOptionsListModal.title'>
			<ManagerWorkplaceCreateOptionsList onSuccess={props.onSuccess} />
		</BaseModal>
	);
};

export default ManagerWorkplaceCreateOptionsListModal;
